import { Component, Input } from '@angular/core';
import { processLogAllColumn } from '@app/modules/custom/components/apps-page/mock-data';
import { translate } from '@ngneat/transloco';
import { BehaviorSubject } from 'rxjs';

import { TableColumn } from '../../interface/table-column.interface';
import { TableData } from '../../interface/table-data.interface';

@Component({
    selector: 'app-process-logdailog',
    templateUrl: './process-logdailog.component.html',
    styleUrls: ['./process-logdailog.component.scss'],
    standalone: false,
})
export class ProcessLogdailogComponent {
    @Input() public resourceId: string;
    @Input() public isPopup = false;

    public allTableColumns: BehaviorSubject<TableColumn[]> = new BehaviorSubject([]);
    public selectedColumns: string[] = ['Header', 'Message', 'createdOn'];
    public tableData: BehaviorSubject<TableData[]> = new BehaviorSubject([]);
    public tableDataSource: TableData[] = [];
    public tableColumns = [
        {
            name: 'Header',
            displayName: translate('Header') as string,
            show: true,
        },
        {
            name: 'Message',
            displayName: translate('Message') as string,
            show: true,
        },
        {
            name: 'createdOn',
            displayName: translate('Created Time') as string,
            show: true,
        },
    ];

    constructor() {}

    public refreshProcessLogs = () => {};

    translateMsg = (msg: string): string => translate(msg);

    ngOnInit(): void {
        this.allTableColumns.next(processLogAllColumn as any);
        this.tableData.next(this.tableDataSource);
    }
}
